<template>
  <b-row style="min-height: 681px">
    <b-col sm="12">
      <b-card>
        <b-row class="mt-sm-2">
          <b-col sm="12">
            <b-row>
              <b-col sm="2">
                                <span class="pr-">
                                    <strong>총 {{ totalRows | numberComma }}건</strong>
                                </span>
              </b-col>
              <b-col sm="6"/>
              <b-col sm="2"></b-col>
              <b-col md="2">
                <b-form-group label-cols-sm="5" label="" class="mb-0">
                  <b-form-select
                    v-model="rowPage"
                    :options="pageOptions"
                    v-on:change="findReportSurvey"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <!-- 로딩 -->
          <b-col sm="12" v-show="listLoading">
            <b-row style="min-height: 634.33px;">
              <b-col sm="5"></b-col>
              <b-col sm="5" class="pt-5 pb-5">
                <PulseLoader color="#20a8d8"></PulseLoader>
              </b-col>
            </b-row>
          </b-col>

          <!-- 목록 -->
          <b-col sm="12" class="pt-sm-1" v-show="!listLoading">
            <b-row>
              <b-col sm="12">
                <b-table outlined :fields="fields" :items="items">
                  <template slot="survey_name" slot-scope="row">
                    <a href="javascript:void(0)" v-on:click="reportSurveyInfoGo(row.item)">{{ row.item.survey_name }}</a>
                  </template>
                  <template slot="use_yn" slot-scope="row">
                    <div style="width:100px;">
                      <c-switch type="text" variant="primary" v-model="row.item.use_yn" v-on:change="surveyUseSwitch(row.item)" on="On" off="Off" :pill="true" :checked="true" style="margin:0px"/>
                    </div>
                  </template>
                  <template slot="download" slot-scope="row">
                    <div style="width:130px; text-align:center">
                      <b-button variant="success" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #187c9f; " 
                                href="javascript:void(0)" 
                                v-on:click="downloadSurveyAnswer(row.item)">
                        <i class="fa fa-file-excel-o"></i> 답변 다운로드
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <!-- 페이징 -->
          <b-col sm="12" class="pt-sm-1">
            <b-row class="pb-sm-2">
              <b-col sm="12" class="my-1">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="rowPage"
                  :limit="limitPage"
                  @input="findReportSurveyPage"
                  align="center"></b-pagination>
              </b-col>
            </b-row>
            <div style="position:absolute; top:8px; right: 15px;">
              <b-button variant="info" style="color:#ffffff; float:right;" v-bind:href="'#/contents/reportSurvey/form'">사이트 추가</b-button>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import Vue from "vue";
import VeeValidate from "vee-validate";

const moment = require("moment");

import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { EventBus } from "../../../event-bus";
import cSwitch from '../../../../components/Switch'

Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: "veeFields",
});

export default {
  name: "extNewsList",
  components: {
    PulseLoader,
    cSwitch
  },
  props: {
    queryParams: {},
    fullDate: {
      type: Array,
    },
  },
  created() {
    // 이벤트 버스 선언
    EventBus.$on("callFindReportSurvey", () => {
      this.findReportSurvey();
    });

    EventBus.$on("findReportSurveyPage", () => {
      this.findReportSurveyPage();
    });

    EventBus.$on('callExtNewsDetailCloseModal', () => {
      this.closeExtNewsDetailModal();
    });
  },
  data() {
    return {
      listLoading: false,
      totalRows: 0,
      currentPage: 1,
      limitPage: 10,
      rowPage: 10,
      pageOptions: [10, 30, 50, 100],
      fields: [
        // { survey_code: { label: "서베이 코드" } },
        { survey_name: { label: "서베이 명" } },
        { dr_code: { label: "보고서 코드" } },
        { report_name: { label: "보고서 명" } },
        { survey_url: { label: "서베이 URL" } },
        { use_yn: { label: "노출여부" } },
        { download: { label: "답변 다운로드" } },
      ],
      items: [],
      isDownload: false,
      formModal: false,
      item: {},
    }
  },
  mounted() {
    this.findReportSurvey();
  },
  methods: {
    // 리포트 서베이 검색
    findReportSurvey() {
      this.currentPage = 1;

      this.listLoading = true;
      // this.queryParams.startDate = this.$parent.getFormatDate(this.fullDate[0]);
      // this.queryParams.endDate = this.$parent.getFormatDate(this.fullDate[1]);

      this.queryParams.rowPage = this.rowPage;
      this.queryParams.currentPage = this.currentPage - 1;

      // console.log('findExtReport > ', this.queryParams);

      var param = encodeURI(JSON.stringify(this.queryParams));
      var data = new FormData();
      data.append("objs", param);

      this.getList(data);
    },
    findReportSurveyPage() {
      this.listLoading = true;
      // this.queryParams.startDate = this.$parent.getFormatDate(this.fullDate[0]);
      // this.queryParams.endDate = this.$parent.getFormatDate(this.fullDate[1]);

      this.queryParams.rowPage = this.rowPage;
      this.queryParams.currentPage = this.currentPage - 1;

      var param = encodeURI(JSON.stringify(this.queryParams));
      var data = new FormData();
      data.append("objs", param);

      this.getList(data);
    },
    getList(data) {
      var token = sessionStorage.getItem("myToken");

      this.$http
        .post("/api/select/reportSurveyList?access_token=" + token, data, null)
        .then((result) => {
          this.listLoading = false;
          const { resultListCount, resultList } = result.data;
          this.totalRows = resultListCount;
          this.items = [];
          this.items = resultList;
          if (this.search_user_id !== "" && this.search_user_id !== undefined) {
            this.$parent.rowSessionSelected();
          }
        });
    },
    addSiteClicked(){
      EventBus.$emit('callNewExtSite');
    },
    reportSurveyInfoGo(row) {
      location.href = '#/contents/reportSurvey/form?survey_code='+row.survey_code;
    },
    downloadSurveyAnswer(row){
      var token = sessionStorage.getItem("myToken");
      this.queryParams.survey_code = row.survey_code;
      var param = encodeURI(JSON.stringify(this.queryParams));

      var data = new FormData();
      data.append('objs', param);

      var config = {
        responseType: 'blob'
      };

      this.$http.post('/download/reportSurveyAnswerExcel', data, config)
        .then((result) => {
          const url = window.URL.createObjectURL(new Blob([result.data]));
          const link = document.createElement('a');
          link.href = url;
          var fileName = row.survey_name + "_답변_" + moment().format('YYYYMMDD');
          link.setAttribute('download', fileName + '.xlsx'); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
    },
    surveyUseSwitch(data) {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      self.queryParams.reg_id = self.$session.get('userId');
      self.queryParams.survey_code = data.survey_code;
      self.queryParams.use_yn = data.use_yn;
      console.log('surveyUseSwitch > ', self.queryParams.survey_code, self.queryParams.use_yn);

      var param = encodeURI(JSON.stringify(self.queryParams));
      var formData = new FormData();
      formData.append('objs', param);

      self.$http.post('/api/update/reportSurveyUseYn?access_token='+token, formData, null)
        .then((result) => {
          console.log("결과",result);
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/contents/reportSurvey/component/ReportSurveyList.vue